import type { CSSProperties } from 'react';

/**
 * Inline CSS custom properties without casting at every call site.
 *
 * The layout utilities (`.row`, `.stack`, `.spread`) read `--gap`, so
 * overriding spacing is a variable, not a new class. React's
 * `CSSProperties` still does not accept `--*` keys, hence one cast
 * here instead of a hundred `as React.CSSProperties` in modules.
 */
export const vars = (values: Record<`--${string}`, string | number>): CSSProperties =>
  values as CSSProperties;
